import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import {  MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { ParamCursoDataService } from '../../../../../../services/curso/param-curso-data.service';
import { ServersSessionsService } from '../../../../../../services/servers-sessions.service';

@Component({
  selector: 'app-info',
  imports: [
    MatCardModule,
    MatDividerModule,
    MatIconModule,
    MatButtonModule,
    CommonModule,
    TranslatePipe
  ],
  templateUrl: './info.html',
  styleUrl: './info.css'
})
export class Info {

  qtd_vagas: string = '';
  url_boleto: string = '';
  url_area_aluno: string = '';

  _paramData = inject(ParamCursoDataService);
  _session_server = inject(ServersSessionsService);

  ngOnInit() {

    this.url_boleto = this._paramData.urlBoleto;
    this._session_server.getUrlSessions().subscribe((url: any) => {

      this.url_area_aluno = window.location.origin + "/dashboard"; 
    });
  }
}
